import { post, get, postExFile } from "@utils/httpUtil";

export function couponSend(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/send`, data, config);
}

export function couponFindById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/findById`, data, config);
}

export function couponUserGetPageInfo(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/getPageInfo`, data, config);
}

export function couponIncrSend(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/coupon/incrSend`, data, config);
}

export function batchUserCouponExpireById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/userCoupon/batchExpireByCondition`, data, config);
}

export function userCouponExpireById(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/userCoupon/expireById`, data, config);
}

export function getUserCouponPage(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/userCoupon/page`, data, config);
}

export function userCouponExport(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return postExFile(`/c/pc/userCoupon/export`, data, config);
}

export function userCouponFindServiceDetail(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`/c/pc/userCoupon/findServiceDetail`, data, config);
}

export function findUserCouponStatusList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return get(`/c/pc/userCoupon/findUserCouponStatusList`, data, config);
}
